// extracted by mini-css-extract-plugin
export default {"circle-progress":"circle-progress__m6dJT","loading-wrapper":"loading-wrapper__mzy+0"};